import React, { useState } from 'react';

import { TagsInput } from '@yubi/yb-core-input-v2';
import { useStyles } from '@yubi/yb-style-provider';

interface ITagsInputView {
  title: string;
  onTagsChange: (tags: string[]) => void;
  tags: string[];
}
const TagsInputView = ({ title, onTagsChange, tags }: ITagsInputView) => {
  const [value, setValue] = useState<string>('');
  const { styleConnector } = useStyles();

  return (
    <div>
      <TagsInput
        tagsProps={{
          getList: (tags: string[] | undefined) => {
            onTagsChange(tags || []);
            setValue('');
          },
        }}
        id="input"
        value={value}
        label={title}
        onChangeText={(text) => {
          setValue(text?.toLocaleString() || '');
        }}
        styleConnector={styleConnector}
        size="l"
        dir="ltr"
      />
    </div>
  );
};

export default TagsInputView;
